import find from 'lodash/find';

export const getPlan = (state) => (plan) => {
    return find(state.plans, { gateway_plan_id: plan });
};

export const getFaq = (state) => (index) => {
    return state.faqs[index];
};

export const getTestimony = (state) => (index) => {
    return state.testimonials[index];
};

export function pricingTableData(state) {
    let data = {};
    state.featureGroups.forEach((group) => {
        data[group.name] = [];
        group.features.forEach((feature, i) => {
            data[group.name].push([feature]);
            state.products.forEach((product) => {
                let prodFeature = product.features.find(
                    (feat) => feat.name === feature.name
                );
                data[group.name][i].push(prodFeature || false);
            });
        });
    });
    return data;
}
